// removed by extract-text-webpack-plugin
module.exports = {"section":"featuredItemsSection-module_section_1h0U6","featuredItemsListDesktop":"featuredItemsSection-module_featuredItemsListDesktop_2r4dX","buttonSection":"featuredItemsSection-module_buttonSection_2O1Mr"};


//////////////////
// WEBPACK FOOTER
// ./client/pages/home/featuredItemsSection/featuredItemsSection.module.css
// module id = 469
// module chunks = 1 3